import BelastingdienstDuoIcon from 'imagesUwKluis/svg/belastingdienst_duo.svg';
import MijnOverheidIcon from 'imagesUwKluis/svg/mijn_overheid.svg';
import MijnPensionoverzichtIcon from 'imagesUwKluis/svg/mijn_pensionoverzicht.svg';
import UwvIcon from 'imagesUwKluis/svg/uwv.svg';
import { Stack } from '../../../shared/layouts';

export const DataSources = {
  'UWV-X': {
    title: 'Mijn UWV',
    icon: <UwvIcon />
  },
  'DUO-X': {
    title: 'Mijn Duo',
    icon: <BelastingdienstDuoIcon />
  },
  'MOH-X': {
    title: 'MijnOverheid',
    icon: <MijnOverheidIcon />
  },
  'UPO-X': {
    title: 'Mijnpensioenoverzicht.nl',
    icon: <MijnPensionoverzichtIcon />
  },
  'VIA-X': {
    title: 'Mijn Belastingdienst',
    icon: <BelastingdienstDuoIcon />
  }
};

const DataSourcesList = ({ sources }) => {
  if (!Array.isArray(sources) || sources.length === 0) return null;
  return sources.map(dataSource => (
    <Stack
      key={`datasource-${dataSource}`}
      direction={'row'}
      space={'s'}
      alignItems={'center'}
    >
      {DataSources[dataSource].icon}
      <span>{DataSources[dataSource].title}</span>
    </Stack>
  ));
};

export default DataSourcesList;
